// extracted by mini-css-extract-plugin
module.exports = {"root":"hub-card-skeleton_root__gPffV","featured":"hub-card-skeleton_featured__dja7L"};